/**
 * @generated SignedSource<<47250061999e373afe89f596ca09ad33>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type modelListProductsPaginationQuery$variables = {
  categoryID?: string | null;
  count?: number | null;
  cursor?: string | null;
  orderBy?: string | null;
  productProvidersIDs?: ReadonlyArray<string> | null;
  productStatusID?: number | null;
  salesChannelsIDs?: ReadonlyArray<string> | null;
  search?: string | null;
  uncategorized?: boolean | null;
};
export type modelListProductsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"productList_models">;
};
export type modelListProductsPaginationQuery = {
  response: modelListProductsPaginationQuery$data;
  variables: modelListProductsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryID"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productProvidersIDs"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productStatusID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelsIDs"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "uncategorized"
  }
],
v1 = {
  "kind": "Variable",
  "name": "categoryID",
  "variableName": "categoryID"
},
v2 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v3 = {
  "kind": "Variable",
  "name": "productProvidersIDs",
  "variableName": "productProvidersIDs"
},
v4 = {
  "kind": "Variable",
  "name": "productStatusID",
  "variableName": "productStatusID"
},
v5 = {
  "kind": "Variable",
  "name": "salesChannelsIDs",
  "variableName": "salesChannelsIDs"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "kind": "Variable",
  "name": "uncategorized",
  "variableName": "uncategorized"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*:: as any*/),
  (v3/*:: as any*/),
  (v4/*:: as any*/),
  (v5/*:: as any*/),
  (v6/*:: as any*/),
  (v7/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v9/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetail",
      "kind": "LinkedField",
      "name": "detail",
      "plural": false,
      "selections": [
        (v9/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesChannelDetailProperties",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            (v10/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ecommerceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remoteUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productsApi",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasProductsApi",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitiveUrl",
          "storageKey": null
        },
        (v9/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "modelListProductsPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "productList_models"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "modelListProductsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": "ModelsConnection",
        "kind": "LinkedField",
        "name": "models",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ModelsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Model",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modelID",
                    "storageKey": null
                  },
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providerCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provider",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productProviderSyncState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "configurationStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "smallImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zakekeEnvironment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canAddAdditionalCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceProductTemplateID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductCategory",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      (v9/*:: as any*/),
                      (v10/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductCode",
                    "kind": "LinkedField",
                    "name": "additionalCodes",
                    "plural": true,
                    "selections": [
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "merchantProductName",
                        "storageKey": null
                      },
                      (v13/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModelColorMapping",
                    "kind": "LinkedField",
                    "name": "modelColorMappings",
                    "plural": true,
                    "selections": [
                      (v14/*:: as any*/),
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "merchantCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PrintType",
                    "kind": "LinkedField",
                    "name": "printingMethods",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "printTypeID",
                        "storageKey": null
                      },
                      (v10/*:: as any*/),
                      (v9/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Color",
                    "kind": "LinkedField",
                    "name": "colors",
                    "plural": true,
                    "selections": [
                      (v14/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "filters": [
          "search",
          "orderBy",
          "salesChannelsIDs",
          "productProvidersIDs",
          "productStatusID",
          "categoryID",
          "uncategorized"
        ],
        "handle": "connection",
        "key": "productsModels_models",
        "kind": "LinkedHandle",
        "name": "models"
      }
    ]
  },
  "params": {
    "cacheID": "641327b3d6ab11a20c2efdf37ced7e94",
    "id": null,
    "metadata": {},
    "name": "modelListProductsPaginationQuery",
    "operationKind": "query",
    "text": "query modelListProductsPaginationQuery(\n  $categoryID: ID = null\n  $count: Int = 20\n  $cursor: String = null\n  $orderBy: String = \"\"\n  $productProvidersIDs: [String!] = null\n  $productStatusID: Int = null\n  $salesChannelsIDs: [String!] = null\n  $search: String = \"\"\n  $uncategorized: Boolean = false\n) {\n  ...productList_models_4vPkxA\n}\n\nfragment productList_models_4vPkxA on Query {\n  models(first: $count, after: $cursor, search: $search, orderBy: $orderBy, salesChannelsIDs: $salesChannelsIDs, productProvidersIDs: $productProvidersIDs, productStatusID: $productStatusID, categoryID: $categoryID, uncategorized: $uncategorized) {\n    edges {\n      node {\n        id\n        name\n        modelID\n        code\n        providerCode\n        provider\n        productProviderSyncState\n        statusID\n        configurationStatus\n        smallImageUrl\n        zakekeEnvironment\n        canAddAdditionalCode\n        sourceProductTemplateID\n        categories {\n          id\n          name\n        }\n        additionalCodes {\n          code\n          salesChannelID\n          merchantProductName\n          salesChannel {\n            id\n            detail {\n              id\n              properties {\n                name\n              }\n            }\n            ecommerceSettings {\n              ecommerceName\n              remoteUrl\n              productsApi\n              hasProductsApi\n              definitiveUrl\n              id\n            }\n          }\n        }\n        modelColorMappings {\n          colorID\n          salesChannelID\n          merchantCode\n        }\n        salesChannel {\n          id\n          detail {\n            id\n            properties {\n              name\n            }\n          }\n          ecommerceSettings {\n            ecommerceName\n            remoteUrl\n            productsApi\n            hasProductsApi\n            definitiveUrl\n            id\n          }\n        }\n        printingMethods {\n          printTypeID\n          name\n          id\n        }\n        colors {\n          colorID\n          name\n          code\n          colorCode\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9217870b9cd6ef5ba30f13fe16c4ba5";

export default node;
